import { component$, type JSX, useContext } from '@builder.io/qwik';
import { getLdArticleEach } from '~/utilities/getLdArticleEach';
import { AppDataContext } from '~/contexts/AppDataContext';

type JsonLdType = {
  type: string;
  data: any;
};

export default component$<JsonLdType>(({ type, data }): JSX.Element => {
  const { payloadToSSR } = useContext(AppDataContext);
  let ld;

  switch (type) {
    case 'articleEach':
      ld = getLdArticleEach(payloadToSSR, data);
      break;
  }

  return <script type='application/ld+json' dangerouslySetInnerHTML={ld} />;
});
